export default __webpack_public_path__ + "static/media/modifyPassword_left.6564dfef.png";